import { Component } from 'react';
import './calculator.scss';
class Calculator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            valuePercent: '',
            valueNumbers: '',
            valueSum: '',
            placeholderNumbers: 'Введите число',
            placeholderPercent: 'Введите проценты',
        }
    }
    onPercent = (e) => {
        this.setState({
           valuePercent: e.target.value,
        })
    }
    onNumbers = (e) => {
        this.setState({
            valueNumbers: e.target.value
        })
    }
    onSubmit = (e) => {
        e.preventDefault();
        if (this.state.valueNumbers && this.state.valuePercent) {
            this.setState({
                valueSum: (+(this.state.valueNumbers) / 100 * +(this.state.valuePercent)).toLocaleString(),
            })
        } else if (this.state.valueNumbers) {
                this.setState({
                    valueSum: 'Введите проценты'
                })
        } else if (this.state.valuePercent) {
            this.setState({
                valueSum: 'Введите число'
            })
         } else {
            this.setState({
                valueSum: 'Введите данные'
            })
        }
    }
    clearValue = () => {
        this.setState({
            valuePercent: '',
            valueNumbers: '',
            valueSum: ''
        })
    }
    render() {
        const { valueSum, valuePercent, valueNumbers, placeholderNumbers, placeholderPercent } = this.state;
        return (
            <div className="calculator" id='calculator'>
                <h2 className="calculator__title">Calculator percent</h2>
                <div className="calculator__container">
                    <div className="calculator__inputs">
                        <input inputMode='numeric' value={valuePercent} onChange={this.onPercent} type="number" required className="calculator__input" id="calculator__percentages" placeholder={placeholderPercent} />
                            <span className="calculator__span">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-percent" viewBox="0 0 16 16">
                                    <path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                                </svg>
                        </span>
                    </div>
                    <div className="calculator__inputs">
                        <input inputMode='numeric' value={valueNumbers} onInput={this.onNumbers} type="number" required className="calculator__input" id="calculator__number" placeholder={placeholderNumbers} />
                            <span className="calculator__span">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-list-ol" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z" />
                                    <path d="M1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 0 1-.492.594v.033a.615.615 0 0 1 .569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 0 0-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z" />
                                </svg>
                            </span>
                    </div>
                    <div className="calculator__buttons">
                        <button className="calculator__btn" onClick={this.onSubmit}>Ок</button>
                        <span className="calculator__reboot" onClick={this.clearValue}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                                <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                            </svg>
                        </span>
                    </div>
                    <div className="calculator__result"> {valueSum} </div>
                </div>
            </div>
        )
    }
}

export default Calculator;